import { Vue, Component } from "vue-property-decorator";
import { utils } from "@hscmap/stellar-globe";
import axios from 'axios'

interface IHipsSurvey {
  ID: string
  obs_title: string
  [name: string]: string
}

@Component
export default class HipsSearchMenuComponent extends Vue {
  rawSearch = ''
  debouncedRawSearchUpdate!: () => void
  surveys: IHipsSurvey[] = []

  created() {
    this.$watch('rawSearch', utils.debounce(200, () => this.search()))
  }

  async search() {
    const q = this.rawSearch
    if (q.trim() !== '') {
      // tslint:disable-next-line:max-line-length
      const url = `//alasky.u-strasbg.fr/MocServer/query?hips_service_url*=*&casesensitive=false&obs_title=${encodeURIComponent(`*${q}*`)}&dataproduct_type=image&dataproduct_subtype=*&get=record&fields=ID,obs_title,hips_service*,hips_status*&fmt=json`
      const { data: result } = await axios.get<IHipsSurvey[]>(url)
      this.surveys = result
    } else {
      this.surveys = []
    }
  }

  select(survey: IHipsSurvey) {
    const baseUrl = this.selectMirror(survey)
    this.$emit('select', { survey, baseUrl })
  }

  private selectMirror(survey: IHipsSurvey) {
    if (location.protocol === 'https:') {
      // if (survey['hips_service_url'].match(/^https:/)) {
      //     return survey['hips_service_url']
      // }
      // let url: string
      // for (let i = 1; url = survey[`hips_service_url_${i}`]; ++i) {
      //     if (url.match(/^https:/))
      //       return url
      // }
      return survey.hips_service_url.replace(/^http:/, 'https:')
    }
    return survey.hips_service_url
  }
}
